import type { AvailableOnSide } from "@tosize/shapes/src/types/finish";
import type { FinishItemPostData } from "@tosize/shapes/src/types/workpiece";
import { type EdgeBand, useEdgeBandsData } from "@tosize/ui";
import { produce } from "immer";
import { usePostDataContext } from "../context/PostDataContext";
import useFinishes from "./useFinishes";

export function useEdgeBands() {
	const { finishes } = useFinishes();
	const { data: postData, setWorkpiece, setSelectedBand } = usePostDataContext();

	const swr = useEdgeBandsData({ sku: postData.sku ?? "", suspense: finishes?.length === 1 });

	function applyEdgeBandOnSides(sides: AvailableOnSide[], band?: EdgeBand) {
		const newBand =
			band ??
			swr.data?.edgeBandsQuery.matching.at(0) ??
			swr.data?.edgeBandsQuery.available.edges?.at(0)?.node;

		const option_parameters: FinishItemPostData["option_parameters"] | undefined =
			newBand?.thickness !== undefined
				? { sku: newBand.sku, thickness: newBand.thickness }
				: undefined;

		if (option_parameters !== undefined) {
			setWorkpiece(
				produce((state) => {
					for (const side of sides) {
						const current = state.finishes.side;

						if (current) {
							current[side.sideCode] = {
								[side.finishCode]: [{ option: "custom", option_parameters }],
							};
						} else {
							console.error("current Finish is undefined");
						}
					}
				}),
			);

			setSelectedBand(newBand);
		}
	}

	return { ...swr, applyEdgeBandOnSides };
}
